import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

export const TeamsApp: ComponentType<unknown> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/teams/app'),
	loading: () => null,
});
